import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { ReadRetailerNetworkLocationGroups } from '@occc-app/App/PolicyBasedAccessControl/userActions';

import { RetailerNetworkGuard } from '../guards/retailer-network.guard';

type RetailerNetworkMyStoresGroupPageGuardProps = {
  children: ReactNode;
};

export const RetailerNetworkMyStoresGroupPageGuard = ({
  children,
}: RetailerNetworkMyStoresGroupPageGuardProps) => {
  const { networkId = '' } = useParams<{ networkId: string }>();

  return (
    <RetailerNetworkGuard policyWithParams={ReadRetailerNetworkLocationGroups({ uuid: networkId })}>
      {children}
    </RetailerNetworkGuard>
  );
};
